import { render, staticRenderFns } from "./intermediateTip.vue?vue&type=template&id=5b57f035&"
import script from "./intermediateTip.vue?vue&type=script&lang=js&"
export * from "./intermediateTip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports